/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const CircleSlash = [
  "svg",
  defaultAttributes,
  [
    ["line", { x1: "9", x2: "15", y1: "15", y2: "9" }],
    ["circle", { cx: "12", cy: "12", r: "10" }]
  ]
];

export { CircleSlash as default };
//# sourceMappingURL=circle-slash.js.map
